import React, { FC } from 'react';
// @ts-ignore
import { NavLink } from 'react-router-dom';
import { AGB_ANCHOR_NAMES, getAGBAnchor } from '../../../../constants/agb';
import Routes from '../../../../constants/routes';
import translation from '../../../../languages';
import './footer.scss';

const Footer: FC<TranslationProps> = ({ t }) => {
    return (
        <footer className='payment-footer'>
            <div className='footer-content'>
                <NavLink to={Routes.AGB.path}>{t('payment.paymentFooter.conditions')}</NavLink> |{' '}
                <NavLink to={`${Routes.AGB.path}${getAGBAnchor(AGB_ANCHOR_NAMES.dataProtection)}`}>
                    {t('payment.paymentFooter.privacyPolicy')}
                </NavLink>
                <span> | </span>
                <NavLink to={`${Routes.AGB.path}${getAGBAnchor(AGB_ANCHOR_NAMES.withdrawalProvisions)}`}>
                    {t('payment.paymentFooter.withdrawalProvisions')}
                </NavLink>{' '}
                <span className='copyright'>
                    &copy; {t('payment.paymentFooter.domainInfo', { year: new Date().getFullYear() })}
                </span>
            </div>
        </footer>
    );
};

const translate = translation('payment');

export default translate(Footer);
